/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Form_Weight_HintInputs */

const vi_carrier_form_weight_hint = /** @type {(inputs: Carrier_Form_Weight_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cước tính theo khối lượng thực tế, nhập đúng số cân của kiện hàng`)
};

/**

* @param {Carrier_Form_Weight_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_form_weight_hint = /** @type {((inputs?: Carrier_Form_Weight_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Form_Weight_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_form_weight_hint(inputs)
});